import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-indigo-50 to-cyan-50 text-slate-800 overflow-hidden relative">
      {/* Animated Blob Background */}
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1 }}
        className="absolute w-[600px] h-[600px] bg-gradient-to-tr from-indigo-400 to-cyan-400 rounded-full blur-3xl opacity-20 animate-pulse"
      ></motion.div>

      {/* 404 Hero SVG Illustration */}
      <motion.svg
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1.2 }}
        viewBox="0 0 1200 600"
        className="w-[90%] max-w-3xl"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="grad1" x1="0" x2="1">
            <stop offset="0%" stopColor="#6366F1" />
            <stop offset="100%" stopColor="#06B6D4" />
          </linearGradient>
          <filter id="blur1">
            <feGaussianBlur stdDeviation="15" />
          </filter>
        </defs>

        {/* Blob background */}
        <motion.path
          d="M100 300 C 100 100, 400 100, 600 180 C 800 260, 1000 100, 1100 300 C 1200 500, 800 500, 600 420 C 400 340, 100 500, 100 300 Z"
          fill="url(#grad1)"
          opacity="0.15"
          filter="url(#blur1)"
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* 404 Text */}
        <motion.text
          x="50%"
          y="55%"
          textAnchor="middle"
          fontSize="180"
          fontWeight="800"
          fill="url(#grad1)"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          404
        </motion.text>

        {/* Subtitle */}
        <motion.text
          x="50%"
          y="72%"
          textAnchor="middle"
          fontSize="28"
          fill="#334155"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          Oops! Page Not Found
        </motion.text>

        {/* Flying paper plane */}
        <motion.g
          animate={{ x: [0, 20, 0], y: [0, -10, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
          <polygon points="580,220 600,230 580,240 586,230" fill="#06B6D4" />
          <polygon points="580,220 595,230 580,240" fill="#22D3EE" opacity="0.8" />
        </motion.g>
      </motion.svg>

      {/* Message Section */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1 }}
        className="text-center z-10"
      >
        <h1 className="text-2xl md:text-3xl font-bold text-slate-700">
          We couldn't find the page you're looking for.
        </h1>
        <p className="text-slate-500 mt-2 max-w-md mx-auto">
          The page may have been moved, deleted, or never existed. Let's get you
          back home safely.
        </p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate("/")}
          className="mt-6 px-6 py-3 bg-gradient-to-r from-indigo-500 to-cyan-500 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition"
        >
          Back to Home
        </motion.button>
      </motion.div>

      {/* Decorative Waves at bottom */}
      <motion.svg
        viewBox="0 0 1440 320"
        className="absolute bottom-0 left-0 w-full h-32 text-indigo-200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          fill="currentColor"
          fillOpacity="1"
          d="M0,224L48,213.3C96,203,192,181,288,176C384,171,480,181,576,202.7C672,224,768,256,864,234.7C960,213,1056,139,1152,101.3C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          animate={{ y: [0, 5, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        />
      </motion.svg>
    </div>
  );
}
